import type { KnowledgeTestInterviewSectionSettings } from "@repo/app-types/entities/interviewSection/settings";
import type { FC } from "react";
import { BaseInterviewSectionDefinitionCard } from "../card.js";
import { KnowledgeTestInterviewSectionDefinitionSettings } from "./settings.js";

export interface KnowledgeTestInterviewSectionDefinitionCardProps {
  interviewSectionDefinitionId: string;
  settings: KnowledgeTestInterviewSectionSettings;
  onChange: (
    interviewSectionDefinitionId: string,
    newSettings: KnowledgeTestInterviewSectionSettings,
  ) => void;
  onDelete: (interviewSectionDefinitionId: string) => void;
}

export const KnowledgeTestInterviewSectionDefinitionCard: FC<
  KnowledgeTestInterviewSectionDefinitionCardProps
> = (props) => {
  return (
    <BaseInterviewSectionDefinitionCard
      interviewSectionDefinitionId={props.interviewSectionDefinitionId}
      title={props.settings.title || "Knowledge test"}
      subtitle="Test and train employee knowledge of products, clients, processes, and more. The AI interviewer will coach the candidate through incorrect answers."
      onDelete={props.onDelete}
    >
      <KnowledgeTestInterviewSectionDefinitionSettings
        interviewSectionDefinitionId={props.interviewSectionDefinitionId}
        settings={props.settings}
        onChange={props.onChange}
      />
    </BaseInterviewSectionDefinitionCard>
  );
};
